/**
 * Do not edit directly
 * Generated on Tue, 29 Aug 2023 16:07:27 GMT
 */

module.exports = {
  "radiusBase": "8px",
  "radiusCircle": "50%",
  "radiusModal": "8px",
  "radiusPill": "100px",
  "widthBase": "1px"
};